// extracted by mini-css-extract-plugin
export default {"copyButton":"CopyButton_copyButton__YGDbb","small":"CopyButton_small__ZRFjZ","medium":"CopyButton_medium__U+8Cx","large":"CopyButton_large__EnXWb"};